import { Category, Gender, StorySlug, Subcategory } from "@/api/episodes-types";
import { CopyButton } from "@/components/ui/CopyButton";
import { Link } from "@/components/ui/Link";
import { pretty, prettyStoryType } from "@/utils/pretty";
import { ArrowBack } from "@mui/icons-material";
import { Breadcrumbs, ButtonBase, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router";

type Props = {
  id: string;
  category: Category;
  story: StorySlug;
  subcategory: Subcategory;
  gender: Gender;
  backToEpisodePageTab?: "masks" | "images";
  linkToEpisodePage?: boolean;
};

export function EpisodeBreadcrumbs({
  id,
  category,
  gender,
  story,
  subcategory,
  backToEpisodePageTab,
  linkToEpisodePage = false,
}: Props) {
  const navigate = useNavigate();

  return (
    <Stack direction={"row"} gap={2} alignItems="center">
      {backToEpisodePageTab && (
        <ButtonBase
          onClick={() =>
            navigate(`/episodes/${id}`, { state: { tab: backToEpisodePageTab } })
          }
        >
          <ArrowBack />
        </ButtonBase>
      )}
      <Breadcrumbs separator="·">
        <CopyButton text={id}>
          {linkToEpisodePage ? (
            <Typography>
              {`Episode ID: `}
              <Link to={`/episodes/${id}`}>{id}</Link>
            </Typography>
          ) : (
            <Typography>{`Episode ID: ${id}`}</Typography>
          )}
        </CopyButton>
        <Typography>{`Story type: ${prettyStoryType(story)}`}</Typography>
        <Typography>{`Category: ${category}`}</Typography>
        <Typography>{`Subcategory: ${subcategory}`}</Typography>
        <Typography>{`Gender: ${pretty(gender)}`}</Typography>
      </Breadcrumbs>
    </Stack>
  );
}
